var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Range } from 'rc-slider';
import uniqueId from 'lodash/uniqueId';
import SliderHandle from './SliderHandle';
import classNames from 'classnames';
import './Slider.scss';

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider() {
    _classCallCheck(this, Slider);

    return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
  }

  _createClass(Slider, [{
    key: 'getRange',
    value: function getRange() {
      var _props = this.props,
          min = _props.min,
          max = _props.max,
          step = _props.step;

      var range = [];

      for (var i = min; i <= max; i += step) {
        range.push(i);
      }

      return range;
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(value) {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;


      return React.createElement(
        'div',
        { className: 'mark' },
        React.createElement('div', { className: 'mark-line' }),
        React.createElement(
          'div',
          { className: 'mark-value' },
          (value === min || value === max) && React.createElement(
            'div',
            null,
            value
          )
        )
      );
    }
  }, {
    key: 'getMarks',
    value: function getMarks() {
      var _this2 = this;

      return this.getRange().reduce(function (acc, cur) {
        acc[cur] = {
          label: _this2.renderLabel(cur)
        };

        return acc;
      }, {});
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var marks = this.props.displayMarks ? this.getMarks() : {};
      var dataHook = this.props.dataHook;

      return React.createElement(
        'div',
        { className: classNames('wix-slider', { rtl: this.props.rtl }), id: this.props.id, 'data-hook': dataHook },
        React.createElement(Range, {
          handle: function handle(props) {
            return React.createElement(SliderHandle, _extends({ key: props.index, displayTooltip: _this3.props.displayTooltip }, props));
          },
          min: this.props.min,
          max: this.props.max,
          value: this.props.value,
          marks: marks,
          step: this.props.step,
          onChange: this.props.onChange,
          onAfterChange: this.props.onAfterChange,
          allowCross: this.props.allowCross
        })
      );
    }
  }]);

  return Slider;
}(Component);

export default Slider;


Slider.propTypes = {
  id: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.number),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onAfterChange: PropTypes.func,
  allowCross: PropTypes.bool,
  displayTooltip: PropTypes.bool,
  displayMarks: PropTypes.bool,
  rtl: PropTypes.bool,
  dataHook: PropTypes.string
};

Slider.defaultProps = {
  min: 1,
  max: 20,
  step: 1,
  value: [2, 7],
  allowCross: true,
  id: uniqueId(),
  displayTooltip: true,
  displayMarks: true,
  rtl: false
};
//# sourceMappingURL=Slider.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Slider/Slider.js